// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30m5V","placeholdersHeader":"styles_placeholdersHeader__3gUd4","editorStyle":"styles_editorStyle__JrLsz","placeholdersBox":"styles_placeholdersBox__3Ysez"};